// eslint-disable-next-line
export default {
    name: "AppSettings",
    status: {
        router: true,
        redux: true
    }
}
